// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   PaymentModal – new design (gpm = generic payment modal)
   ============================================================ */

.gpm-drawer-paper {
  top: 12px !important;
  bottom: 12px !important;
  right: 12px !important;
  height: calc(100vh - 24px) !important;
  width: min(1120px, calc(100vw - 24px)) !important;
  border-radius: 28px !important;
  background-color: #ffffff !important;
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.7) !important;
}

.gpm-edc-badge {
  display: flex;
  height: 44px;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid;
  padding: 0 14px;
  font-size: 0.75rem;
  font-weight: 600;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: opacity 0.2s;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.gpm-edc-badge.connected {
  border-color: #d1fae5;
  background-color: rgba(236, 253, 245, 0.8);
  color: #334155;
}
.gpm-edc-badge.disconnected {
  border-color: #fee2e2;
  background-color: rgba(254, 242, 242, 0.8);
  color: #334155;
}
.gpm-edc-dot {
  width: 10px;
  height: 10px;
  border-radius: 9999px;
}
.gpm-edc-badge.connected .gpm-edc-dot {
  background-color: #10b981;
}
.gpm-edc-badge.disconnected .gpm-edc-dot {
  background-color: #ef4444;
}
.gpm-edc-badge svg {
  width: 16px;
  height: 16px;
}
.gpm-edc-badge.connected svg {
  color: #10b981;
}
.gpm-edc-badge.disconnected svg {
  color: #ef4444;
}
.gpm-edc-badge.force-offline {
  border-color: #fed7aa;
  background-color: rgba(255, 247, 237, 0.9);
  color: #334155;
  animation: none;
}
.gpm-edc-badge.force-offline .gpm-edc-dot {
  background-color: #f97316;
}

/* Shell ---------------------------------------------------- */
.gpm-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: radial-gradient(circle at top right, rgba(42, 113, 255, 0.08), transparent 32%),
    linear-gradient(180deg, #f8fafc 0%, #ffffff 18%);
}

/* Header --------------------------------------------------- */
.gpm-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, rgba(248, 250, 252, 0.96), rgba(255, 255, 255, 0.92));
  flex-shrink: 0;
}

.gpm-header-left h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.gpm-header-left p {
  font-size: 0.8rem;
  color: #64748b;
  margin: 4px 0 0 0;
}

.gpm-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.gpm-bill-btn {
  display: flex;
  height: 44px;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid #cbd5e1;
  padding: 0 14px;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s;
  background-color: #ffffff;
  color: #334155;
  cursor: pointer;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.gpm-bill-btn:hover {
  border-color: #94a3b8;
  background-color: #f8fafc;
}

.gpm-bill-btn svg {
  width: 16px;
  height: 16px;
}

.gpm-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: 9999px;
  border: 1px solid transparent;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: background-color 0.2s;
}

.gpm-close-btn:hover:not(:disabled) {
  background-color: #e2e8f0;
}

.gpm-close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.gpm-close-btn svg {
  width: 20px;
  height: 20px;
  color: #64748b;
}

/* Methods section ------------------------------------------ */
.gpm-methods-section {
  border-bottom: 1px solid rgba(226, 232, 240, 0.7);
  background-color: rgba(255, 255, 255, 0.85);
  padding: 16px 24px;
  backdrop-filter: blur(8px);
  flex-shrink: 0;
}

.gpm-methods-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  color: #94a3b8;
  margin-bottom: 0;
}

.gpm-methods-row {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(9, minmax(0, 1fr));
  gap: 8px;
}

.gpm-method-card {
  display: flex;
  min-height: 78px;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  padding: 12px 8px;
  text-align: center;
  transition: all 0.2s;
  background-color: rgba(255, 255, 255, 0.9);
  color: #475569;
  cursor: pointer;
  box-shadow: none;
}

.gpm-method-card:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.gpm-method-card:hover:not(.active):not(:disabled) {
  background-color: #f8fafc;
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
}

.gpm-method-card.active {
  border-color: #020617;
  background-color: #020617;
  color: #ffffff;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
}

.gpm-method-card span {
  font-size: 11px;
  font-weight: 700;
  line-height: 1.25;
  display: block;
  color: currentColor;
}

.gpm-method-icon-wrap {
  display: flex;
  height: 36px;
  width: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background-color: #f1f5f9;
  transition: background-color 0.2s;
}

.gpm-method-card.active .gpm-method-icon-wrap {
  background-color: rgba(255, 255, 255, 0.1);
}

.gpm-method-icon-wrap svg {
  width: 16px;
  height: 16px;
  color: currentColor;
  stroke: currentColor;
}

/* Body – two-column ---------------------------------------- */
.gpm-body {
  display: grid;
  grid-template-columns: minmax(420px, 0.8fr) minmax(0, 1.2fr);
  gap: 16px;
  padding: 20px 24px;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

/* Active-tender card (left) -------------------------------- */
.gpm-at-card {
  border-radius: 28px;
  border: 1px solid #e2e8f0;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.96));
  padding: 20px;
  box-shadow: 0 18px 40px -28px rgba(15, 23, 42, 0.35);
  display: flex;
  flex-direction: column;
  height: fit-content;
}

.gpm-at-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  color: #94a3b8;
  margin: 0;
}

.gpm-at-name-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
}

.gpm-at-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
}

.gpm-terminal-badge {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px solid #10b981;
  background: #ecfdf5;
  font-size: 0.7rem;
  font-weight: 600;
  color: #047857;
}

.gpm-terminal-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #10b981;
}

/* Stats row */
.gpm-stats-row {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.gpm-stat-box {
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 12px 16px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.gpm-stat-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8;
  margin: 0;
}

.gpm-stat-value {
  margin-top: 4px;
  font-size: 1.125rem;
  font-weight: 900;
  color: #0f172a;
}

.gpm-stat-value.red {
  color: #ea580c;
}

.gpm-stat-value.green {
  color: #10b981;
}

/* Settlement summary */
.gpm-settlement-card {
  margin-top: 16px;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  padding: 20px;
  background-color: #f8fafc;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.gpm-settlement-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8;
}

.gpm-settlement-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.gpm-settlement-text {
  font-size: 0.85rem;
  color: #64748b;
  margin: 0;
}

.gpm-settlement-amount {
  font-size: 1.875rem;
  font-weight: 700;
  color: #94a3b8;
  white-space: nowrap;
}

.gpm-settlement-card.has-change {
  background-color: #f0fdf4;
  border-color: #bbf7d0;
}

.gpm-settlement-card.has-change .gpm-settlement-label,
.gpm-settlement-card.has-change .gpm-settlement-amount {
  color: #15803d;
}

.gpm-settlement-card.has-remaining {
  background-color: #fef2f2;
  border-color: #fec8c8;
}

.gpm-settlement-card.has-remaining .gpm-settlement-label,
.gpm-settlement-card.has-remaining .gpm-settlement-amount {
  color: #c10007;
}

/* Right panel card */
.gpm-right-card {
  border-radius: 28px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: rgba(255, 255, 255, 0.8);
  padding: 16px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: fit-content;
}

.gpm-rp-ready-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  color: #94a3b8;
  margin: 0;
}

.gpm-rp-method-name {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin-top: -8px;
}

.gpm-amount-display {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 16px 20px;
}

.gpm-amount-display-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8;
}

.gpm-amount-display-value {
  font-size: 1.75rem;
  font-weight: 800;
  color: #0f172a;
  margin-top: 4px;
}

/* Cash input */
.gpm-cash-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 28px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.05);
  backdrop-filter: blur(8px);
  animation: fadeInSlideUp 0.3s ease-out;
}
@keyframes fadeInSlideUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.gpm-cash-input-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
}

.gpm-cash-input-box {
  position: relative;
  border: none;
  border-radius: 0;
  overflow: visible;
  background: transparent;
  box-shadow: none;
}

.gpm-cash-rupee {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.125rem;
  font-weight: 700;
  color: #94a3b8;
  border: none;
  background: transparent;
  height: auto;
  display: inline-block;
  pointer-events: none;
  line-height: normal;
  padding: 0;
}

.gpm-cash-input {
  display: flex;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 0 12px 0 40px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  height: 56px;
  background-color: #f8fafc;
  font-size: 1.25rem;
  font-weight: 700;
  transition: all 0.2s;
  outline: none;
  box-sizing: border-box;
}

.gpm-cash-input:focus {
  background-color: #ffffff;
  border-color: #3b82f6;
  box-shadow:
    0 0 0 1px #3b82f6,
    0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

/* Quick amount chips */
.gpm-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.gpm-chip {
  border-radius: 8px;
  background-color: #f1f5f9;
  padding: 6px 12px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #475569;
  border: none;
  transition: background-color 0.2s;
  cursor: pointer;
}

.gpm-chip:hover {
  background-color: #e2e8f0;
}

.gpm-chip-exact {
  border: 1px solid #dbeafe;
  background-color: #eff6ff;
  color: #2563eb;
}

.gpm-chip-exact:hover {
  background-color: #dbeafe;
}

.gpm-change-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 12px;
  margin-top: 12px;
}

.gpm-change-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #15803d;
}

.gpm-change-value {
  font-size: 1rem;
  font-weight: 700;
  color: #15803d;
}

.gpm-backspace-hint {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.72rem;
  color: #2563eb;
  font-weight: 500;
}

.gpm-terminal-info {
  font-size: 0.875rem;
  color: #475569;
  line-height: 1.5;
  margin: 0;
}

/* Keypad area in cash mode */
.gpm-keypad-area {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

/* ============================================================
   SPLIT MODE body
   ============================================================ */
.gpm-split-body {
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  background-color: transparent;
}

.gpm-split-card {
  border-radius: 28px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: rgba(255, 255, 255, 0.85);
  padding: 20px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.05);
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: fadeInSlideUp 0.3s ease-out;
}

.gpm-split-tabs-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
}

.gpm-split-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  flex: 1;
}

.gpm-split-tab {
  border-radius: 16px;
  border: 1px solid #cbd5e1;
  padding: 14px;
  text-align: left;
  transition: all 0.2s;
  background-color: #f8fafc;
  color: #334155;
  cursor: pointer;
  outline: none;
}

.gpm-split-tab:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.gpm-split-tab-title {
  font-size: 0.875rem;
  font-weight: 700;
  margin: 0;
  line-height: normal;
}

.gpm-split-tab.active {
  border-color: #020617;
  background-color: #020617;
  color: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.gpm-split-cancel-btn {
  border-radius: 16px;
  border: 1px solid #fca5a5;
  background-color: #ffffff;
  color: #dc2626;
  padding: 14px 16px;
  font-size: 0.875rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.gpm-split-cancel-btn:hover:not(:disabled) {
  background-color: #fef2f2;
  border-color: #dc2626;
}

.gpm-split-cancel-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.gpm-split-panels {
  display: grid;
  gap: 12px;
  align-items: start;
}

@media (min-width: 1024px) {
  .gpm-split-panels {
    grid-template-columns: minmax(0, 0.88fr) minmax(320px, 1.12fr);
  }
}

@media (min-width: 1280px) {
  .gpm-split-panels {
    grid-template-columns: minmax(0, 0.92fr) minmax(360px, 1.08fr);
    gap: 16px;
  }
}

/* LEFT PANEL: Captured so far */
.gpm-split-panel-captured {
  border-radius: 16px;
  border: 1px solid #cbd5e1;
  background-color: rgba(248, 250, 252, 0.7);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

@media (min-width: 1024px) {
  .gpm-split-panel-captured {
    padding: 16px;
  }
}

.gpm-split-captured-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.gpm-split-captured-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.gpm-split-captured-subtitle {
  font-size: 0.75rem;
  color: #64748b;
  margin: 4px 0 0 0;
  line-height: 1.25;
}

.gpm-split-captured-badge {
  background-color: #ffffff;
  border-radius: 9999px;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #64748b;
  white-space: nowrap;
}

.gpm-split-captured-empty {
  border-radius: 16px;
  border: 1px dashed #cbd5e1;
  background-color: #ffffff;
  padding: 20px 16px;
  font-size: 0.875rem;
  color: #64748b;
  text-align: center;
}

.gpm-split-payments-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gpm-split-payment-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.02);
}

.gpm-split-payment-method {
  font-size: 0.875rem;
  font-weight: 600;
  color: #334155;
}

.gpm-split-payment-amt {
  font-size: 0.875rem;
  font-weight: 700;
  color: #0f172a;
}

/* Primary Payment (1st item in captured list) style */
.gpm-split-primary-payment {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid #a7f3d0;
  background-color: #ffffff;
  padding: 12px 16px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.gpm-split-primary-label {
  font-size: 0.875rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.gpm-split-primary-method {
  margin-top: 4px;
  font-size: 0.75rem;
  color: #64748b;
  margin: 0;
}

.gpm-split-primary-right {
  text-align: right;
}

.gpm-split-primary-amount {
  font-size: 1rem;
  font-weight: 700;
  color: #047857;
  margin: 0;
}

.gpm-split-primary-status {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #059669;
  margin: 0;
}

/* RIGHT PANEL: Add next payment */
.gpm-split-panel-add {
  border-radius: 16px;
  border: 1px solid #cbd5e1;
  background-color: rgba(248, 250, 252, 0.8);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (min-width: 1024px) {
  .gpm-split-panel-add {
    padding: 16px;
  }
}

.gpm-split-add-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

@media (min-width: 640px) {
  .gpm-split-add-header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.gpm-split-add-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.gpm-split-add-subtitle {
  font-size: 0.75rem;
  color: #64748b;
  margin: 4px 0 0 0;
  line-height: 1.25;
}

.gpm-use-remaining-btn {
  width: 100%;
  border-radius: 9999px;
  border: 1px solid #bfdbfe;
  background-color: #eff6ff;
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #1d4ed8;
  cursor: pointer;
  transition: background-color 0.2s;
  text-align: center;
}

@media (min-width: 640px) {
  .gpm-use-remaining-btn {
    width: auto;
  }
}

.gpm-use-remaining-btn:hover:not(:disabled) {
  background-color: #dbeafe;
}

.gpm-use-remaining-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.gpm-split-inputs-row {
  display: grid;
  gap: 12px;
  margin-top: 16px;
}

@media (min-width: 1024px) {
  .gpm-split-inputs-row {
    grid-template-columns: minmax(0, 1fr) 150px;
  }
}

@media (min-width: 1280px) {
  .gpm-split-inputs-row {
    grid-template-columns: minmax(0, 1fr) 170px;
  }
}

.gpm-split-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gpm-split-field-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #0f172a;
}

.gpm-split-select {
  height: 44px;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  padding: 0 16px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #334155;
  outline: none;
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
}

.gpm-split-select:focus {
  border-color: #3b82f6;
}

.gpm-split-select:disabled {
  background-color: #cbd5e1;
  opacity: 0.6;
  cursor: not-allowed;
}

.gpm-split-input {
  display: flex;
  height: 44px;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  padding: 0 16px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #0f172a;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box;
}

.gpm-split-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

.gpm-split-input:disabled {
  background-color: #cbd5e1;
  opacity: 0.6;
  cursor: not-allowed;
}

.gpm-split-warning {
  font-size: 0.75rem;
  color: #ef4444;
  font-weight: 600;
  line-height: 1.4;
  margin-top: 4px;
  margin-bottom: 0;
}

.gpm-split-bottom-hint {
  margin-top: 12px;
  border-radius: 16px;
  border: 1px dashed #cbd5e1;
  background-color: #ffffff;
  padding: 12px 16px;
  font-size: 0.875rem;
  color: #475569;
}

.gpm-split-hint-total {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #1e293b;
}

/* ============================================================
   Footer
   ============================================================ */
.gpm-footer {
  border-top: 1px solid #f1f5f9;
  background-color: rgba(255, 255, 255, 0.95);
  padding: 24px;
  backdrop-filter: blur(24px);
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

.gpm-tip-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  transition: all 0.2s;
  height: 56px;
  min-height: 36px;
  padding: 0 16px;
  border-radius: 16px;
  border: 1px solid #fde68a;
  background-color: #fef3c7;
  font-size: 1rem;
  font-weight: 700;
  color: #b45309;
  cursor: pointer;
  width: 100%;
  max-width: 168px;
}

.gpm-tip-btn:hover {
  background-color: #fde68a;
  color: #92400e;
}

.gpm-pay-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  transition: all 0.2s;
  height: 56px;
  min-height: 40px;
  padding: 0 32px;
  border-radius: 16px;
  font-size: 1.125rem;
  font-weight: 700;
  background-color: #2563eb;
  color: #ffffff;
  border: 1px solid #1d4ed8;
  box-shadow:
    0 20px 25px -5px rgba(37, 99, 235, 0.2),
    0 10px 10px -5px rgba(37, 99, 235, 0.2);
  cursor: pointer;
  width: 100%;
  max-width: 340px;
  margin-left: auto;
}

.gpm-pay-btn:hover:not(:disabled) {
  background-color: #1d4ed8;
  border-color: #1e40af;
}

.gpm-pay-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.gpm-pay-btn-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: gpm-spin 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes gpm-spin {
  to { transform: rotate(360deg); }
}

/* ============================================================
   Bill Summary Overlay
   ============================================================ */
.gpm-bill-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1600;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.gpm-bill-card {
  width: 360px;
  max-height: 80vh;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.25);
}

.gpm-bill-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
  padding: 20px;
  color: #fff;
  position: relative;
  flex-shrink: 0;
}

.gpm-bill-header-label {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 4px;
}

.gpm-bill-header-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 2px 0;
}

.gpm-bill-header-sub {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

.gpm-bill-header-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  transition: background 0.15s;
}

.gpm-bill-header-close:hover {
  background: rgba(255, 255, 255, 0.35);
}

.gpm-bill-body {
  background: #fff;
  overflow-y: auto;
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gpm-bill-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 6px 0;
}

.gpm-bill-item-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #111827;
  flex: 1;
}

.gpm-bill-item-qty {
  font-size: 0.78rem;
  color: #6b7280;
  margin-right: 12px;
}

.gpm-bill-item-value {
  font-size: 0.85rem;
  font-weight: 600;
  color: #111827;
}

.gpm-bill-divider {
  border: none;
  border-top: 1.5px dashed #e2e8f0;
  margin: 4px 0;
}

.gpm-bill-summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.82rem;
  color: #6b7280;
  padding: 3px 0;
}

.gpm-bill-summary-row span:last-child {
  font-weight: 600;
  color: #374151;
}

.gpm-bill-grand {
  background: #111827;
  border-radius: 10px;
  padding: 14px 16px;
  margin-top: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.gpm-bill-grand-label {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.gpm-bill-grand-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: #fff;
}

.gpm-bill-grand-includes {
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.55);
}

.gpm-bill-grand-amount {
  font-size: 1.4rem;
  font-weight: 800;
  color: #fff;
}

/* ============================================================
   Payment loader screens (centered wrapper)
   ============================================================ */
.gpm-loader-shell {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  flex: 1;
  height: 100%;
}

.gpm-loader-shell.success {
  background: radial-gradient(circle at top, rgba(16, 185, 129, 0.12), transparent 30%), #ffffff;
  padding: 32px;
  text-align: center;
  animation: successZoomIn 0.5s ease-out;
  height: 100%;
}

@keyframes successZoomIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.gpm-loader-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
  padding: 24px;
  max-width: 400px;
  width: 100%;
}

.gpm-loader-shell.success .gpm-loader-box {
  max-width: 100%;
  width: 100%;
  height: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* keep legacy class names for loader gif elements */
.process-wrapper-box {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.process-wrapper-txt {
  font-size: 1.1rem;
  font-weight: 700;
  text-align: center;
  color: #111827;
}

.input-wrapper-manual {
  width: 100%;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 1rem;
}

.bottom-btn-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.failed-img-gif-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
}

.failed-img-gif {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.loading-img-gif {
  width: 140px;
  height: 140px;
  object-fit: contain;
}

.loading-img-gif-success {
  width: 160px;
  height: 160px;
  object-fit: contain;
}

.payemnt-failed-txt {
  font-size: 1rem;
  font-weight: 700;
  color: #dc2626;
  text-align: center;
}

.payment-progress-text {
  font-size: 1rem;
  font-weight: 700;
  color: #111827;
}

.styledButton-wrapper-box {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 12px;
}

.payment-success-main-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.success-icon-wrapper {
  width: 128px;
  height: 128px;
  background-color: #ecfdf5;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  position: relative;
}

.success-icon-check {
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-check-svg {
  width: 64px;
  height: 64px;
  color: #10b981;
}

.success-icon-pulse {
  position: absolute;
  inset: 0;
  border: 4px solid #d1fae5;
  border-radius: 9999px;
  opacity: 0;
  transform: scale(1.05);
}

.success-title {
  font-size: 1.875rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
  margin-top: 0;
}

.success-amount {
  color: #64748b;
  font-size: 1.125rem;
  margin-bottom: 8px;
  margin-top: 0;
}

.success-method {
  font-size: 0.875rem;
  font-weight: 500;
  color: #047857;
  margin-bottom: 12px;
  margin-top: 0;
}

.success-actions-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
  max-width: 448px;
  margin-bottom: 48px;
}

.success-action-btn {
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 500;
  min-height: 2.25rem;
  padding: 8px 16px;
  height: 96px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 16px;
  border: 2px solid #cbd5e1;
  background-color: #ffffff;
  transition: all 0.2s;
}

.success-action-btn:disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}

.success-action-btn:not(:disabled) {
  cursor: pointer;
}

.success-action-btn:not(:disabled):hover {
  background-color: #f8fafc;
  border-color: #94a3b8;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}

.success-action-btn:not(:disabled):active {
  background-color: #f1f5f9;
}

.success-action-svg {
  width: 32px;
  height: 32px;
  opacity: 0.8;
}

.font-bold {
  font-weight: 700;
}

.success-footer-btns {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 448px;
}

.gpm-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 500;
  min-height: 2.5rem;
  height: 56px;
  padding: 0 48px;
  border-radius: 16px;
  background-color: #0f172a !important;
  color: #ffffff !important;
  border: 1px solid #0f172a !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  cursor: pointer;
  transition: all 0.2s;
  outline: none !important;
}

.gpm-btn-primary:hover:not(:disabled) {
  background-color: #1e293b !important;
  border-color: #1e293b !important;
  color: #ffffff !important;
}

.gpm-btn-primary:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.gpm-btn-primary:focus,
.gpm-btn-primary:focus-visible,
.gpm-btn-primary:active,
.gpm-loader-shell .continue-btn-wrapper:focus,
.gpm-loader-shell .continue-btn-wrapper:focus-visible,
.gpm-loader-shell .continue-btn-wrapper:active {
  background-color: #0f172a !important;
  color: #ffffff !important;
  border-color: #0f172a !important;
  outline: none !important;
}

.gpm-loader-shell .reprint-btn-wrapper:focus,
.gpm-loader-shell .reprint-btn-wrapper:focus-visible,
.gpm-loader-shell .reprint-btn-wrapper:active {
  background-color: #ffffff !important;
  color: #0f172a !important;
  border-color: #cbd5e1 !important;
  outline: none !important;
}

.gpm-btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 500;
  min-height: 2.5rem;
  height: 56px;
  padding: 0 48px;
  border-radius: 16px;
  background-color: #ffffff;
  color: #0f172a;
  border: 1px solid #cbd5e1;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}

.gpm-btn-secondary:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.success-home-svg {
  width: 20px;
  height: 20px;
  margin-left: 8px;
}

.payment-success-btn-wrapper-box {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.payment-cancel {
  font-size: 1rem;
  font-weight: 700;
  color: #dc2626;
  text-align: center;
}

.cancel-wrapper-btn {
  margin: 0 auto;
  display: block;
}

.reprint-btn-wrapper {
  min-width: 160px;
}

.continue-btn-wrapper {
  min-width: 120px;
}

.orderNumber {
  color: #2563eb;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/paymentModal/index.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,qCAAqC;EACrC,iDAAiD;EACjD,8BAA8B;EAC9B,oCAAoC;EACpC,+DAA+D;EAC/D,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,wBAAwB;EACxB,yDAAyD;AAC3D;AACA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB;oDACkD;AACpD;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yFAAyF;EACzF,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,iDAAiD;EACjD,2CAA2C;EAC3C,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;EAClB,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yFAAyF;EACzF,aAAa;EACb,oDAAoD;EACpD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,8CAA8C;EAC9C,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,8CAA8C;EAC9C,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,2CAA2C;EAC3C,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB;;mCAEiC;AACnC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,OAAO;EACP,aAAa;AACf;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,8CAA8C;EAC9C,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mFAAmF;AACrF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,8DAA8D;EAChE;AACF;;AAEA;EACE;IACE,8DAA8D;IAC9D,SAAS;EACX;AACF;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;iEAEiE;AACjE;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;EACb,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB;;2CAEyC;EACzC,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;;iEAEiE;AACjE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,8FAA8F;EAC9F,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kFAAkF;AACpF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;EACpC,gGAAgG;EAChG,eAAe;EACf,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;;;;;;EAME,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,2CAA2C;EAC3C,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* ============================================================\n   PaymentModal – new design (gpm = generic payment modal)\n   ============================================================ */\n\n.gpm-drawer-paper {\n  top: 12px !important;\n  bottom: 12px !important;\n  right: 12px !important;\n  height: calc(100vh - 24px) !important;\n  width: min(1120px, calc(100vw - 24px)) !important;\n  border-radius: 28px !important;\n  background-color: #ffffff !important;\n  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.7) !important;\n}\n\n.gpm-edc-badge {\n  display: flex;\n  height: 44px;\n  align-items: center;\n  gap: 8px;\n  border-radius: 16px;\n  border: 1px solid;\n  padding: 0 14px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: opacity 0.2s;\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n.gpm-edc-badge.connected {\n  border-color: #d1fae5;\n  background-color: rgba(236, 253, 245, 0.8);\n  color: #334155;\n}\n.gpm-edc-badge.disconnected {\n  border-color: #fee2e2;\n  background-color: rgba(254, 242, 242, 0.8);\n  color: #334155;\n}\n.gpm-edc-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 9999px;\n}\n.gpm-edc-badge.connected .gpm-edc-dot {\n  background-color: #10b981;\n}\n.gpm-edc-badge.disconnected .gpm-edc-dot {\n  background-color: #ef4444;\n}\n.gpm-edc-badge svg {\n  width: 16px;\n  height: 16px;\n}\n.gpm-edc-badge.connected svg {\n  color: #10b981;\n}\n.gpm-edc-badge.disconnected svg {\n  color: #ef4444;\n}\n.gpm-edc-badge.force-offline {\n  border-color: #fed7aa;\n  background-color: rgba(255, 247, 237, 0.9);\n  color: #334155;\n  animation: none;\n}\n.gpm-edc-badge.force-offline .gpm-edc-dot {\n  background-color: #f97316;\n}\n\n/* Shell ---------------------------------------------------- */\n.gpm-shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n  background: radial-gradient(circle at top right, rgba(42, 113, 255, 0.08), transparent 32%),\n    linear-gradient(180deg, #f8fafc 0%, #ffffff 18%);\n}\n\n/* Header --------------------------------------------------- */\n.gpm-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 32px;\n  border-bottom: 1px solid #f1f5f9;\n  background: linear-gradient(135deg, rgba(248, 250, 252, 0.96), rgba(255, 255, 255, 0.92));\n  flex-shrink: 0;\n}\n\n.gpm-header-left h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.gpm-header-left p {\n  font-size: 0.8rem;\n  color: #64748b;\n  margin: 4px 0 0 0;\n}\n\n.gpm-header-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.gpm-bill-btn {\n  display: flex;\n  height: 44px;\n  align-items: center;\n  gap: 8px;\n  border-radius: 16px;\n  border: 1px solid #cbd5e1;\n  padding: 0 14px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s;\n  background-color: #ffffff;\n  color: #334155;\n  cursor: pointer;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.gpm-bill-btn:hover {\n  border-color: #94a3b8;\n  background-color: #f8fafc;\n}\n\n.gpm-bill-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.gpm-close-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  width: 40px;\n  border-radius: 9999px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.gpm-close-btn:hover:not(:disabled) {\n  background-color: #e2e8f0;\n}\n\n.gpm-close-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.gpm-close-btn svg {\n  width: 20px;\n  height: 20px;\n  color: #64748b;\n}\n\n/* Methods section ------------------------------------------ */\n.gpm-methods-section {\n  border-bottom: 1px solid rgba(226, 232, 240, 0.7);\n  background-color: rgba(255, 255, 255, 0.85);\n  padding: 16px 24px;\n  backdrop-filter: blur(8px);\n  flex-shrink: 0;\n}\n\n.gpm-methods-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.22em;\n  color: #94a3b8;\n  margin-bottom: 0;\n}\n\n.gpm-methods-row {\n  margin-top: 16px;\n  display: grid;\n  grid-template-columns: repeat(9, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.gpm-method-card {\n  display: flex;\n  min-height: 78px;\n  min-width: 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  padding: 12px 8px;\n  text-align: center;\n  transition: all 0.2s;\n  background-color: rgba(255, 255, 255, 0.9);\n  color: #475569;\n  cursor: pointer;\n  box-shadow: none;\n}\n\n.gpm-method-card:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.gpm-method-card:hover:not(.active):not(:disabled) {\n  background-color: #f8fafc;\n  border-color: #cbd5e1;\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);\n}\n\n.gpm-method-card.active {\n  border-color: #020617;\n  background-color: #020617;\n  color: #ffffff;\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);\n}\n\n.gpm-method-card span {\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.25;\n  display: block;\n  color: currentColor;\n}\n\n.gpm-method-icon-wrap {\n  display: flex;\n  height: 36px;\n  width: 36px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  background-color: #f1f5f9;\n  transition: background-color 0.2s;\n}\n\n.gpm-method-card.active .gpm-method-icon-wrap {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.gpm-method-icon-wrap svg {\n  width: 16px;\n  height: 16px;\n  color: currentColor;\n  stroke: currentColor;\n}\n\n/* Body – two-column ---------------------------------------- */\n.gpm-body {\n  display: grid;\n  grid-template-columns: minmax(420px, 0.8fr) minmax(0, 1.2fr);\n  gap: 16px;\n  padding: 20px 24px;\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n/* Active-tender card (left) -------------------------------- */\n.gpm-at-card {\n  border-radius: 28px;\n  border: 1px solid #e2e8f0;\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.96));\n  padding: 20px;\n  box-shadow: 0 18px 40px -28px rgba(15, 23, 42, 0.35);\n  display: flex;\n  flex-direction: column;\n  height: fit-content;\n}\n\n.gpm-at-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.22em;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.gpm-at-name-row {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.gpm-at-name {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.gpm-terminal-badge {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  border: 1px solid #10b981;\n  background: #ecfdf5;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #047857;\n}\n\n.gpm-terminal-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #10b981;\n}\n\n/* Stats row */\n.gpm-stats-row {\n  margin-top: 20px;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.gpm-stat-box {\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 12px 16px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.gpm-stat-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.gpm-stat-value {\n  margin-top: 4px;\n  font-size: 1.125rem;\n  font-weight: 900;\n  color: #0f172a;\n}\n\n.gpm-stat-value.red {\n  color: #ea580c;\n}\n\n.gpm-stat-value.green {\n  color: #10b981;\n}\n\n/* Settlement summary */\n.gpm-settlement-card {\n  margin-top: 16px;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  padding: 20px;\n  background-color: #f8fafc;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.gpm-settlement-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8;\n}\n\n.gpm-settlement-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.gpm-settlement-text {\n  font-size: 0.85rem;\n  color: #64748b;\n  margin: 0;\n}\n\n.gpm-settlement-amount {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.gpm-settlement-card.has-change {\n  background-color: #f0fdf4;\n  border-color: #bbf7d0;\n}\n\n.gpm-settlement-card.has-change .gpm-settlement-label,\n.gpm-settlement-card.has-change .gpm-settlement-amount {\n  color: #15803d;\n}\n\n.gpm-settlement-card.has-remaining {\n  background-color: #fef2f2;\n  border-color: #fec8c8;\n}\n\n.gpm-settlement-card.has-remaining .gpm-settlement-label,\n.gpm-settlement-card.has-remaining .gpm-settlement-amount {\n  color: #c10007;\n}\n\n/* Right panel card */\n.gpm-right-card {\n  border-radius: 28px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: rgba(255, 255, 255, 0.8);\n  padding: 16px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(8px);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  height: fit-content;\n}\n\n.gpm-rp-ready-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.22em;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.gpm-rp-method-name {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-top: -8px;\n}\n\n.gpm-amount-display {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 16px 20px;\n}\n\n.gpm-amount-display-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8;\n}\n\n.gpm-amount-display-value {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #0f172a;\n  margin-top: 4px;\n}\n\n/* Cash input */\n.gpm-cash-input-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border-radius: 28px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: rgba(255, 255, 255, 0.9);\n  padding: 20px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.05);\n  backdrop-filter: blur(8px);\n  animation: fadeInSlideUp 0.3s ease-out;\n}\n@keyframes fadeInSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.gpm-cash-input-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.gpm-cash-input-box {\n  position: relative;\n  border: none;\n  border-radius: 0;\n  overflow: visible;\n  background: transparent;\n  box-shadow: none;\n}\n\n.gpm-cash-rupee {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #94a3b8;\n  border: none;\n  background: transparent;\n  height: auto;\n  display: inline-block;\n  pointer-events: none;\n  line-height: normal;\n  padding: 0;\n}\n\n.gpm-cash-input {\n  display: flex;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  padding: 0 12px 0 40px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  height: 56px;\n  background-color: #f8fafc;\n  font-size: 1.25rem;\n  font-weight: 700;\n  transition: all 0.2s;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.gpm-cash-input:focus {\n  background-color: #ffffff;\n  border-color: #3b82f6;\n  box-shadow:\n    0 0 0 1px #3b82f6,\n    0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n/* Quick amount chips */\n.gpm-chips-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.gpm-chip {\n  border-radius: 8px;\n  background-color: #f1f5f9;\n  padding: 6px 12px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #475569;\n  border: none;\n  transition: background-color 0.2s;\n  cursor: pointer;\n}\n\n.gpm-chip:hover {\n  background-color: #e2e8f0;\n}\n\n.gpm-chip-exact {\n  border: 1px solid #dbeafe;\n  background-color: #eff6ff;\n  color: #2563eb;\n}\n\n.gpm-chip-exact:hover {\n  background-color: #dbeafe;\n}\n\n.gpm-change-display {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background-color: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 12px;\n  margin-top: 12px;\n}\n\n.gpm-change-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #15803d;\n}\n\n.gpm-change-value {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #15803d;\n}\n\n.gpm-backspace-hint {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.72rem;\n  color: #2563eb;\n  font-weight: 500;\n}\n\n.gpm-terminal-info {\n  font-size: 0.875rem;\n  color: #475569;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Keypad area in cash mode */\n.gpm-keypad-area {\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n/* ============================================================\n   SPLIT MODE body\n   ============================================================ */\n.gpm-split-body {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 24px;\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  background-color: transparent;\n}\n\n.gpm-split-card {\n  border-radius: 28px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: rgba(255, 255, 255, 0.85);\n  padding: 20px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.05);\n  backdrop-filter: blur(8px);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  animation: fadeInSlideUp 0.3s ease-out;\n}\n\n.gpm-split-tabs-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.gpm-split-tabs {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  flex: 1;\n}\n\n.gpm-split-tab {\n  border-radius: 16px;\n  border: 1px solid #cbd5e1;\n  padding: 14px;\n  text-align: left;\n  transition: all 0.2s;\n  background-color: #f8fafc;\n  color: #334155;\n  cursor: pointer;\n  outline: none;\n}\n\n.gpm-split-tab:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.gpm-split-tab-title {\n  font-size: 0.875rem;\n  font-weight: 700;\n  margin: 0;\n  line-height: normal;\n}\n\n.gpm-split-tab.active {\n  border-color: #020617;\n  background-color: #020617;\n  color: #ffffff;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n.gpm-split-cancel-btn {\n  border-radius: 16px;\n  border: 1px solid #fca5a5;\n  background-color: #ffffff;\n  color: #dc2626;\n  padding: 14px 16px;\n  font-size: 0.875rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.gpm-split-cancel-btn:hover:not(:disabled) {\n  background-color: #fef2f2;\n  border-color: #dc2626;\n}\n\n.gpm-split-cancel-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.gpm-split-panels {\n  display: grid;\n  gap: 12px;\n  align-items: start;\n}\n\n@media (min-width: 1024px) {\n  .gpm-split-panels {\n    grid-template-columns: minmax(0, 0.88fr) minmax(320px, 1.12fr);\n  }\n}\n\n@media (min-width: 1280px) {\n  .gpm-split-panels {\n    grid-template-columns: minmax(0, 0.92fr) minmax(360px, 1.08fr);\n    gap: 16px;\n  }\n}\n\n/* LEFT PANEL: Captured so far */\n.gpm-split-panel-captured {\n  border-radius: 16px;\n  border: 1px solid #cbd5e1;\n  background-color: rgba(248, 250, 252, 0.7);\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n@media (min-width: 1024px) {\n  .gpm-split-panel-captured {\n    padding: 16px;\n  }\n}\n\n.gpm-split-captured-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.gpm-split-captured-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.gpm-split-captured-subtitle {\n  font-size: 0.75rem;\n  color: #64748b;\n  margin: 4px 0 0 0;\n  line-height: 1.25;\n}\n\n.gpm-split-captured-badge {\n  background-color: #ffffff;\n  border-radius: 9999px;\n  padding: 4px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.gpm-split-captured-empty {\n  border-radius: 16px;\n  border: 1px dashed #cbd5e1;\n  background-color: #ffffff;\n  padding: 20px 16px;\n  font-size: 0.875rem;\n  color: #64748b;\n  text-align: center;\n}\n\n.gpm-split-payments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.gpm-split-payment-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background-color: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.02);\n}\n\n.gpm-split-payment-method {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n.gpm-split-payment-amt {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n/* Primary Payment (1st item in captured list) style */\n.gpm-split-primary-payment {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border-radius: 16px;\n  border: 1px solid #a7f3d0;\n  background-color: #ffffff;\n  padding: 12px 16px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.gpm-split-primary-label {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.gpm-split-primary-method {\n  margin-top: 4px;\n  font-size: 0.75rem;\n  color: #64748b;\n  margin: 0;\n}\n\n.gpm-split-primary-right {\n  text-align: right;\n}\n\n.gpm-split-primary-amount {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #047857;\n  margin: 0;\n}\n\n.gpm-split-primary-status {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #059669;\n  margin: 0;\n}\n\n/* RIGHT PANEL: Add next payment */\n.gpm-split-panel-add {\n  border-radius: 16px;\n  border: 1px solid #cbd5e1;\n  background-color: rgba(248, 250, 252, 0.8);\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n@media (min-width: 1024px) {\n  .gpm-split-panel-add {\n    padding: 16px;\n  }\n}\n\n.gpm-split-add-header {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n@media (min-width: 640px) {\n  .gpm-split-add-header {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.gpm-split-add-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.gpm-split-add-subtitle {\n  font-size: 0.75rem;\n  color: #64748b;\n  margin: 4px 0 0 0;\n  line-height: 1.25;\n}\n\n.gpm-use-remaining-btn {\n  width: 100%;\n  border-radius: 9999px;\n  border: 1px solid #bfdbfe;\n  background-color: #eff6ff;\n  padding: 6px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #1d4ed8;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  text-align: center;\n}\n\n@media (min-width: 640px) {\n  .gpm-use-remaining-btn {\n    width: auto;\n  }\n}\n\n.gpm-use-remaining-btn:hover:not(:disabled) {\n  background-color: #dbeafe;\n}\n\n.gpm-use-remaining-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.gpm-split-inputs-row {\n  display: grid;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n@media (min-width: 1024px) {\n  .gpm-split-inputs-row {\n    grid-template-columns: minmax(0, 1fr) 150px;\n  }\n}\n\n@media (min-width: 1280px) {\n  .gpm-split-inputs-row {\n    grid-template-columns: minmax(0, 1fr) 170px;\n  }\n}\n\n.gpm-split-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.gpm-split-field-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.gpm-split-select {\n  height: 44px;\n  width: 100%;\n  border-radius: 16px;\n  border: 1px solid #cbd5e1;\n  background-color: #ffffff;\n  padding: 0 16px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #334155;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.gpm-split-select:focus {\n  border-color: #3b82f6;\n}\n\n.gpm-split-select:disabled {\n  background-color: #cbd5e1;\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.gpm-split-input {\n  display: flex;\n  height: 44px;\n  width: 100%;\n  border-radius: 16px;\n  border: 1px solid #cbd5e1;\n  background-color: #ffffff;\n  padding: 0 16px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #0f172a;\n  outline: none;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.gpm-split-input:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n\n.gpm-split-input:disabled {\n  background-color: #cbd5e1;\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.gpm-split-warning {\n  font-size: 0.75rem;\n  color: #ef4444;\n  font-weight: 600;\n  line-height: 1.4;\n  margin-top: 4px;\n  margin-bottom: 0;\n}\n\n.gpm-split-bottom-hint {\n  margin-top: 12px;\n  border-radius: 16px;\n  border: 1px dashed #cbd5e1;\n  background-color: #ffffff;\n  padding: 12px 16px;\n  font-size: 0.875rem;\n  color: #475569;\n}\n\n.gpm-split-hint-total {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: #1e293b;\n}\n\n/* ============================================================\n   Footer\n   ============================================================ */\n.gpm-footer {\n  border-top: 1px solid #f1f5f9;\n  background-color: rgba(255, 255, 255, 0.95);\n  padding: 24px;\n  backdrop-filter: blur(24px);\n  flex-shrink: 0;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n}\n\n.gpm-tip-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  transition: all 0.2s;\n  height: 56px;\n  min-height: 36px;\n  padding: 0 16px;\n  border-radius: 16px;\n  border: 1px solid #fde68a;\n  background-color: #fef3c7;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #b45309;\n  cursor: pointer;\n  width: 100%;\n  max-width: 168px;\n}\n\n.gpm-tip-btn:hover {\n  background-color: #fde68a;\n  color: #92400e;\n}\n\n.gpm-pay-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  transition: all 0.2s;\n  height: 56px;\n  min-height: 40px;\n  padding: 0 32px;\n  border-radius: 16px;\n  font-size: 1.125rem;\n  font-weight: 700;\n  background-color: #2563eb;\n  color: #ffffff;\n  border: 1px solid #1d4ed8;\n  box-shadow:\n    0 20px 25px -5px rgba(37, 99, 235, 0.2),\n    0 10px 10px -5px rgba(37, 99, 235, 0.2);\n  cursor: pointer;\n  width: 100%;\n  max-width: 340px;\n  margin-left: auto;\n}\n\n.gpm-pay-btn:hover:not(:disabled) {\n  background-color: #1d4ed8;\n  border-color: #1e40af;\n}\n\n.gpm-pay-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.gpm-pay-btn-spinner {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: gpm-spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes gpm-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ============================================================\n   Bill Summary Overlay\n   ============================================================ */\n.gpm-bill-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1600;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.gpm-bill-card {\n  width: 360px;\n  max-height: 80vh;\n  border-radius: 16px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.25);\n}\n\n.gpm-bill-header {\n  background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);\n  padding: 20px;\n  color: #fff;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.gpm-bill-header-label {\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.65);\n  margin-bottom: 4px;\n}\n\n.gpm-bill-header-title {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 2px 0;\n}\n\n.gpm-bill-header-sub {\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.7);\n  margin: 0;\n}\n\n.gpm-bill-header-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255, 255, 255, 0.2);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  transition: background 0.15s;\n}\n\n.gpm-bill-header-close:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n.gpm-bill-body {\n  background: #fff;\n  overflow-y: auto;\n  flex: 1;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.gpm-bill-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 6px 0;\n}\n\n.gpm-bill-item-name {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #111827;\n  flex: 1;\n}\n\n.gpm-bill-item-qty {\n  font-size: 0.78rem;\n  color: #6b7280;\n  margin-right: 12px;\n}\n\n.gpm-bill-item-value {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.gpm-bill-divider {\n  border: none;\n  border-top: 1.5px dashed #e2e8f0;\n  margin: 4px 0;\n}\n\n.gpm-bill-summary-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.82rem;\n  color: #6b7280;\n  padding: 3px 0;\n}\n\n.gpm-bill-summary-row span:last-child {\n  font-weight: 600;\n  color: #374151;\n}\n\n.gpm-bill-grand {\n  background: #111827;\n  border-radius: 10px;\n  padding: 14px 16px;\n  margin-top: 4px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.gpm-bill-grand-label {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.gpm-bill-grand-title {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.gpm-bill-grand-includes {\n  font-size: 0.7rem;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.gpm-bill-grand-amount {\n  font-size: 1.4rem;\n  font-weight: 800;\n  color: #fff;\n}\n\n/* ============================================================\n   Payment loader screens (centered wrapper)\n   ============================================================ */\n.gpm-loader-shell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 320px;\n  flex: 1;\n  height: 100%;\n}\n\n.gpm-loader-shell.success {\n  background: radial-gradient(circle at top, rgba(16, 185, 129, 0.12), transparent 30%), #ffffff;\n  padding: 32px;\n  text-align: center;\n  animation: successZoomIn 0.5s ease-out;\n  height: 100%;\n}\n\n@keyframes successZoomIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.gpm-loader-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  text-align: center;\n  padding: 24px;\n  max-width: 400px;\n  width: 100%;\n}\n\n.gpm-loader-shell.success .gpm-loader-box {\n  max-width: 100%;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* keep legacy class names for loader gif elements */\n.process-wrapper-box {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.process-wrapper-txt {\n  font-size: 1.1rem;\n  font-weight: 700;\n  text-align: center;\n  color: #111827;\n}\n\n.input-wrapper-manual {\n  width: 100%;\n  border: 1.5px solid #d1d5db;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 1rem;\n}\n\n.bottom-btn-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n.failed-img-gif-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 12px 0;\n}\n\n.failed-img-gif {\n  width: 80px;\n  height: 80px;\n  object-fit: contain;\n}\n\n.loading-img-gif {\n  width: 140px;\n  height: 140px;\n  object-fit: contain;\n}\n\n.loading-img-gif-success {\n  width: 160px;\n  height: 160px;\n  object-fit: contain;\n}\n\n.payemnt-failed-txt {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #dc2626;\n  text-align: center;\n}\n\n.payment-progress-text {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #111827;\n}\n\n.styledButton-wrapper-box {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.payment-success-main-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.success-icon-wrapper {\n  width: 128px;\n  height: 128px;\n  background-color: #ecfdf5;\n  border-radius: 9999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 32px;\n  position: relative;\n}\n\n.success-icon-check {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.success-check-svg {\n  width: 64px;\n  height: 64px;\n  color: #10b981;\n}\n\n.success-icon-pulse {\n  position: absolute;\n  inset: 0;\n  border: 4px solid #d1fae5;\n  border-radius: 9999px;\n  opacity: 0;\n  transform: scale(1.05);\n}\n\n.success-title {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 8px;\n  margin-top: 0;\n}\n\n.success-amount {\n  color: #64748b;\n  font-size: 1.125rem;\n  margin-bottom: 8px;\n  margin-top: 0;\n}\n\n.success-method {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #047857;\n  margin-bottom: 12px;\n  margin-top: 0;\n}\n\n.success-actions-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  width: 100%;\n  max-width: 448px;\n  margin-bottom: 48px;\n}\n\n.success-action-btn {\n  white-space: nowrap;\n  font-size: 0.875rem;\n  font-weight: 500;\n  min-height: 2.25rem;\n  padding: 8px 16px;\n  height: 96px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: 16px;\n  border: 2px solid #cbd5e1;\n  background-color: #ffffff;\n  transition: all 0.2s;\n}\n\n.success-action-btn:disabled {\n  pointer-events: none;\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.success-action-btn:not(:disabled) {\n  cursor: pointer;\n}\n\n.success-action-btn:not(:disabled):hover {\n  background-color: #f8fafc;\n  border-color: #94a3b8;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n}\n\n.success-action-btn:not(:disabled):active {\n  background-color: #f1f5f9;\n}\n\n.success-action-svg {\n  width: 32px;\n  height: 32px;\n  opacity: 0.8;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.success-footer-btns {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 448px;\n}\n\n.gpm-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  font-weight: 500;\n  min-height: 2.5rem;\n  height: 56px;\n  padding: 0 48px;\n  border-radius: 16px;\n  background-color: #0f172a !important;\n  color: #ffffff !important;\n  border: 1px solid #0f172a !important;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;\n  cursor: pointer;\n  transition: all 0.2s;\n  outline: none !important;\n}\n\n.gpm-btn-primary:hover:not(:disabled) {\n  background-color: #1e293b !important;\n  border-color: #1e293b !important;\n  color: #ffffff !important;\n}\n\n.gpm-btn-primary:disabled {\n  opacity: 0.5 !important;\n  cursor: not-allowed !important;\n}\n\n.gpm-btn-primary:focus,\n.gpm-btn-primary:focus-visible,\n.gpm-btn-primary:active,\n.gpm-loader-shell .continue-btn-wrapper:focus,\n.gpm-loader-shell .continue-btn-wrapper:focus-visible,\n.gpm-loader-shell .continue-btn-wrapper:active {\n  background-color: #0f172a !important;\n  color: #ffffff !important;\n  border-color: #0f172a !important;\n  outline: none !important;\n}\n\n.gpm-loader-shell .reprint-btn-wrapper:focus,\n.gpm-loader-shell .reprint-btn-wrapper:focus-visible,\n.gpm-loader-shell .reprint-btn-wrapper:active {\n  background-color: #ffffff !important;\n  color: #0f172a !important;\n  border-color: #cbd5e1 !important;\n  outline: none !important;\n}\n\n.gpm-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  font-weight: 500;\n  min-height: 2.5rem;\n  height: 56px;\n  padding: 0 48px;\n  border-radius: 16px;\n  background-color: #ffffff;\n  color: #0f172a;\n  border: 1px solid #cbd5e1;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  transition: all 0.2s;\n  outline: none;\n}\n\n.gpm-btn-secondary:hover {\n  background-color: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.success-home-svg {\n  width: 20px;\n  height: 20px;\n  margin-left: 8px;\n}\n\n.payment-success-btn-wrapper-box {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.payment-cancel {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #dc2626;\n  text-align: center;\n}\n\n.cancel-wrapper-btn {\n  margin: 0 auto;\n  display: block;\n}\n\n.reprint-btn-wrapper {\n  min-width: 160px;\n}\n\n.continue-btn-wrapper {\n  min-width: 120px;\n}\n\n.orderNumber {\n  color: #2563eb;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
